import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  standalone: false,
  selector: 'pptl-modal-download',
  templateUrl: 'modal-download.component.html',
  styleUrls: ['modal-download.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ModalDownloadComponent {
  @Input()
  modalTitle: string;
  modalText: string;
  modalOkButton: string;

  constructor(public modalController: ModalController) {}

  onCancelButtonClick() {
    this.modalController.dismiss({ status: 'cancel' });
  }

  onOkButtonClick(): void {
    this.modalController.dismiss({ status: 'ok' });
  }
}
